import { Button, styled } from '@mui/material'
import { ComponentProps } from 'react'

const SCustomButton = styled(Button)`
  font-size: 14px;
  text-transform: uppercase;
  height: 52px;
  color: #142954;
  &.bordered {
    border: 1.5px solid #142954;
    border-radius: 3px;
  }
  &.contained {
    color: white;
    border-radius: 3px;
    background-color: #142954;
  }
  &.confirm {
    color: #f9f9fa;
    border-radius: 3px;
    background-color: #f64a14;
  }
  &.approve {
    color: #f9f9fa;
    border-radius: 3px;
    background-color: #4caf50;
  }
  &.refused {
    color: #FFF;
    border-radius: 3px;
    background-color: #dd062f;
  }
  &.disabled {
    color: white;
    border-radius: 3px;
    background-color: darkgray;
  }
  &.view {
    background-color: transparent;
    color: #2e363e;
    opacity: 0.87;
    text-transform: none;
    text-decoration: underline;
    height: fit-content;
    padding: 0;
  }
  &.framed {
    height: 44px;
    text-transform: capitalize;
    font-size: 14px;
    color: #2e363e;
    border: 1.5px solid #c4c4c4;
  }
  &.default-width {
    max-width: 192px;
    width: 100%;
    text-transform: initial;
    font-size: 16px;
    font-weight: 400;
  }
  &.secondary {
    color: #142954;
    border-radius: 3px;
    background-color: #e8eaee;
    &[disabled] {
      background-color: #f3f4f6;
      color: #b4bac9;
    }
  }
  &.inactive {
    background-color: #f3f4f6;
    color: #b4bac9;
  }
`
export interface ICustomButtom extends ComponentProps<typeof Button> {
  defaultWidth?: boolean
  variable:
    | 'default'
    | 'bordered'
    | 'contained'
    | 'confirm'
    | 'approve'
    | 'refused'
    | 'disabled'
    | 'view'
    | 'framed'
    | 'secondary'
    | 'inactive'
}

function CustomButton({ children, variable, defaultWidth, ...props }: ICustomButtom) {
  const className = defaultWidth ? `${variable} default-width` : variable
  return (
    <SCustomButton className={className} {...props}>
      {children}
    </SCustomButton>
  )
}

export default CustomButton
